module.exports = __webpack_public_path__ + "img/share_style_head@2x.7ffc4137.png";